import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupervisorService {

  api_url = environment.EVENT_MANAGEMENT_API +'supervisor-monitoring?SupervisorId='
  //test url
  //test_api_url = 'https://fidelity-eventmgmt-staging-testing.azurewebsites.net/api/supervisor-monitoring?SupervisorId='
  constructor(private httpClient: HttpClient) { }

  getPosts(id, token){

   // id = "73172f6b-64e0-4b4b-b381-5801db9205bc";
    //token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyRGF0YSI6IntcInVzZXJJZFwiOlwiNzMxNzJmNmItNjRlMC00YjRiLWIzODEtNTgwMWRiOTIwNWJjXCIsXCJkaXNwbGF5TmFtZVwiOlwiUmVzcG9uc2UgT2ZmaWNlclwiLFwiZW1haWxcIjpcInJvQGZpZGVsaXR5LXNlcnZpY2VzLmNvLnphXCIsXCJjc3NDbGFzc1wiOm51bGwsXCJjb2xvckNvZGVcIjpudWxsLFwidXNlclN0YXR1c0lkXCI6OSxcInByb2ZpbGVJbWFnZVVybFwiOlwiXCIsXCJyb2xlTmFtZVwiOlwiUmVzcG9uc2UgT2ZmaWNlclwiLFwicm9sZUlkXCI6XCIwZTk4NWY4Yy0yZWY3LTQ5YjYtOWFiMS04ZWNjOTNiNjk2YWFcIixcImVtcGxveWVlSWRcIjpcIjAxZjUwZGIwLTRkOWYtNDNhYi1iMzE2LTM5OTdhOWQyNzhmMFwiLFwid2FyZWhvdXNlSWRcIjpudWxsfSIsIm5iZiI6MTYwODczMTU1OCwiZXhwIjoxNjA4NzM4NzU4LCJpYXQiOjE2MDg3MzE1NTh9.3vT4J1vPwcPSottdpdVi2LWhtdTFalvhY-lCpywj28c";
    return this.httpClient.get(this.api_url+id, {
      headers: new HttpHeaders()
        .set('Authorization',  `${token}`)
    })
  }
}
